import { render, staticRenderFns } from "./Punish.vue?vue&type=template&id=da86d536&scoped=true"
import script from "./Punish.vue?vue&type=script&lang=js"
export * from "./Punish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da86d536",
  null
  
)

export default component.exports